import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { layersMenuStyles, paper } from '@constants/mui-theme';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { getToolbarConfig } from '@selectors/map-selector';
import { togglePois, setMapTypeId, toggleTraffic, toggleBicycle, toggleTransit } from '@actions/map-actions';
import { getMapStylers } from '@utils/map-utils';
import PoiMarkerIcon from '@icons/poi-marker-icon';
import { textColor } from '@constants/colors';
import DefaultMapTypeIcon from '@icons/data-uri-icon/default-map-type-icon';
import SatelliteMapTypeIcon from '@icons/data-uri-icon/satellite-map-type-icon';
import TerrainMapTypeIcon from '@icons/data-uri-icon/terrain-map-type-icon';
import { Icon } from '@mui';
import './layers-menu.scss';

const CompactFormControlLabel = withStyles({
  root: {
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
    justifyContent: 'space-between'
  }
})(FormControlLabel);

const RadioFormControlLabel = withStyles({
  root: {
    margin: 0,
    width: '100%',
    justifyContent: 'space-between'
  }
})(FormControlLabel);

const CompactRadio = withStyles({
  root: {
    padding: 0
  }
})(Radio);

const CompactSwitch = withStyles({
  root: {
    padding: 4,
    width: 40,
    height: 24
  },
  switchBase: {
    padding: 4,
    '&$checked': {
      transform: 'translateX(16px)'
    }
  },
  thumb: {
    width: 16,
    height: 16
  },
  track: {
    borderRadius: 10
  },
  checked: {}
})(Switch);

class LayersMenu extends Component {
  componentDidMount() {
    if (this.props.poisOn && window.mapInstance) {
      window.mapInstance.setOptions({styles: getMapStylers(this.props.poisOn, this.props.transit)});
    }
  }

  componentDidUpdate(prevProps) {
    if ((prevProps.poisOn !== this.props.poisOn || prevProps.transit !== this.props.transit) && window.mapInstance) {
      window.mapInstance.setOptions({styles: getMapStylers(this.props.poisOn, this.props.transit)});
    }
  }

  setMapType = event => {
    this.props.setMapTypeId(event.target.value);
  };

  render() {
    const { layersMenuOpen, style } = this.props;
    if (!layersMenuOpen) {
      return null;
    }
    const { traffic, transit, bicycle, toolsConfig } = this.props;
    const {
      traffic: trafficConfig = true,
      transit: transitConfig = true,
      bicycle: bicycleConfig = true
    } = toolsConfig;
    const { mapTypeId } = this.props;

    return (
      <div styleName={`container ${this.props.small ? 'small' : ''}`} style={{ ...style, ...paper }}>
        <div styleName="header">MAP TYPE</div>
        <div>
          <RadioGroup
            name="layer-controls"
            value={mapTypeId}
            onChange={this.setMapType}
            style={layersMenuStyles.radioGroup.style}
          >
            <RadioFormControlLabel
              value="roadmap"
              control={<CompactRadio color="primary" size="small" />}
              label={
                <div styleName="label"><DefaultMapTypeIcon style={layersMenuStyles.menuIcons} />Default</div>
              }
              labelPlacement="start"
              style={layersMenuStyles.radio.style}
            />
            <RadioFormControlLabel
              value="hybrid"
              control={<CompactRadio color="primary" size="small" />}
              label={
                <div styleName="label"><SatelliteMapTypeIcon style={layersMenuStyles.menuIcons} />Satellite</div>
              }
              labelPlacement="start"
              style={layersMenuStyles.radio.style}
            />
            <RadioFormControlLabel
              value="terrain"
              control={<CompactRadio color="primary" size="small" />}
              label={
                <div styleName="label"><TerrainMapTypeIcon style={layersMenuStyles.menuIcons} />Terrain</div>
              }
              labelPlacement="start"
              style={layersMenuStyles.radio.style}
            />
          </RadioGroup>
        </div>
        <div styleName="header">MAP DETAILS</div>
        <div>
          <div styleName="input">
            <CompactFormControlLabel
              labelPlacement="start"
              control={
                <CompactSwitch
                  checked={this.props.poisOn}
                  onChange={this.props.togglePois}
                  color="primary"
                />
              }
              label={<div styleName="label"><PoiMarkerIcon color={textColor} />Places</div>}
            />
          </div>
          {trafficConfig &&
            <div styleName="input">
              <CompactFormControlLabel
                labelPlacement="start"
                control={
                  <CompactSwitch
                    checked={traffic}
                    onChange={this.props.toggleTraffic}
                    color="primary"
                  />
                }
                label={<div styleName="label"><Icon role="img">traffic</Icon>Traffic</div>}
              />
            </div>
          }
          {transitConfig &&
            <div styleName="input">
              <CompactFormControlLabel
                labelPlacement="start"
                control={
                  <CompactSwitch
                    checked={transit}
                    onChange={this.props.toggleTransit}
                    color="primary"
                  />
                }
                label={<div styleName="label"><Icon role="img">directions_transit</Icon>Transit</div>}
              />
            </div>
          }
          {bicycleConfig &&
            <div styleName="input">
              <CompactFormControlLabel
                labelPlacement="start"
                control={
                  <CompactSwitch
                    checked={bicycle}
                    onChange={this.props.toggleBicycle}
                    color="primary"
                  />
                }
                label={<div styleName="label"><Icon role="img">directions_bike</Icon>Biking</div>}
              />
            </div>
          }
        </div>
      </div>
    );
  }
}

LayersMenu.propTypes = {
  bicycle: PropTypes.bool,
  layersMenuOpen: PropTypes.bool,
  mapTypeId: PropTypes.string,
  poisOn: PropTypes.bool,
  setMapTypeId: PropTypes.func,
  small: PropTypes.bool,
  style: PropTypes.object,
  toggleBicycle: PropTypes.func,
  togglePois: PropTypes.func,
  toggleTraffic: PropTypes.func,
  toggleTransit: PropTypes.func,
  toolsConfig: PropTypes.object,
  traffic: PropTypes.bool,
  transit: PropTypes.bool
};


const mapStateToProps = state => {
  const { traffic, transit, bicycle, layersMenuOpen, mapTypeId } = state.map;
  const { poisOn } = state.map.markers;
  const toolsConfig = getToolbarConfig(state);
  return { traffic, transit, bicycle, poisOn, toolsConfig, mapTypeId, layersMenuOpen };
};

export default connect(mapStateToProps, {
  togglePois,
  toggleTraffic,
  toggleTransit,
  toggleBicycle,
  setMapTypeId
})(LayersMenu);
